import { memo } from 'react';
import { FormInput } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

/**
 * UserInputNode — canvas card for USER_INPUT nodes.
 * Uses BaseNodeUI so it is identical in size/shape to all other platform nodes
 * (200×64px, rounded-xl, icon on left, title + badge on right).
 *
 * Field details belong in the PropertiesPanel (right panel), not the canvas card.
 */

const MODE_LABELS: Record<string, string> = {
  pre_run_modal:  'Pre-Run',
  inline_panel:   'Inline',
  mid_flow_pause: 'Pause',
};

const UserInputNode = memo(({ data, selected }: any) => {
  const fields  = data?.fields || [];
  const mode    = data?.mode   || 'pre_run_modal';
  const title   = data?.form_title || data?.label || 'User Input';
  const modeLabel = MODE_LABELS[mode] ?? 'Pre-Run';

  const badge =
    fields.length > 0
      ? `${fields.length} field${fields.length > 1 ? 's' : ''} · ${modeLabel}`
      : modeLabel;

  return (
    <BaseNodeUI
      title={title}
      icon={FormInput}
      colorClass=""
      bgClass="bg-gradient-to-br from-amber-400 to-orange-500"
      selected={selected}
      executionStatus={data?.executionStatus}
    >
      {/* Shown on the right side of the card — matches how other nodes show "Data Prep", "Smart Fill" etc. */}
      {badge}
    </BaseNodeUI>
  );
});

UserInputNode.displayName = 'UserInputNode';
export default UserInputNode;
